import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilePricePipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/file/file-price.pipe';
import { ProductPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/product/product.pipe';
import { FilePriceWithVoucherPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/file/file-price-with-voucher.pipe';
import { NamePacketPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/package/name-packet.pipe';
import { NamePhotoGroupPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/photo/name-photo-group.pipe';
import { NameProductPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/product/name-product.pipe';
import { PackagePhotoPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/package/package-photo.pipe';
import { PackagePricePipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/package/package-price.pipe';
import { PhotoDataPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/photo/photo-data.pipe';
import { PriceToAddToFirstPrintPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/print/price-to-add-to-first-print.pipe';
import { ProductPriceWithVoucherPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/product/product-price-with-voucher.pipe';
import { PrintPricePipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/print/print-price.pipe';
import { PrintPriceWithVoucherPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/print/print-price-with-voucher.pipe';
import { ProductInShopPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/product/product-in-shop.pipe';
import { ProductInPackagePhotoPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/package/product-in-package-photo.pipe';
import { ProductPriceParserModule } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/product-price-parser/product-price-parser.module';
import { ProductPricePipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/product/product-price.pipe';
import { ProductPhotoPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/product/product-photo.pipe';
import { OneTextFromListPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/product/one-text-from-list.pipe';
import { CheckedOrUncheckedPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/product/checked-or-unchecked.pipe';
import { SumOfProductsInBasketOfTheSelectedPhotoPipe } from './pipe/photo/sum-of-products-in-basket-of-the-selected-photo.pipe';
import { LookBookPricePipe } from './pipe/lookbook/lookbook-price.pipe';
import { PrintFramePricePipe } from './pipe/print/print-frame-price.pipe';
import { FileNamePipe } from './pipe/file/file-name.pipe';
import { TabloPricePipe } from './pipe/tablo-price.pipe';

@NgModule({
  declarations: [
    FilePricePipe,
    ProductPipe,
    FilePriceWithVoucherPipe,
    NamePacketPipe,
    NamePhotoGroupPipe,
    NameProductPipe,
    PackagePhotoPipe,
    PackagePricePipe,
    PhotoDataPipe,
    PriceToAddToFirstPrintPipe,
    ProductPriceWithVoucherPipe,
    PrintPricePipe,
    PrintPriceWithVoucherPipe,
    ProductInShopPipe,
    ProductInPackagePhotoPipe,
    ProductPricePipe,
    ProductPhotoPipe,
    OneTextFromListPipe,
    CheckedOrUncheckedPipe,
    SumOfProductsInBasketOfTheSelectedPhotoPipe,
    LookBookPricePipe,
    PrintFramePricePipe,
    FileNamePipe,
    TabloPricePipe,
  ],
  imports: [CommonModule, ProductPriceParserModule],
  exports: [
    FilePricePipe,
    ProductPipe,
    FilePriceWithVoucherPipe,
    NamePacketPipe,
    NamePhotoGroupPipe,
    NameProductPipe,
    PackagePhotoPipe,
    PackagePricePipe,
    PhotoDataPipe,
    PriceToAddToFirstPrintPipe,
    ProductPriceWithVoucherPipe,
    PrintPricePipe,
    PrintPriceWithVoucherPipe,
    ProductInShopPipe,
    ProductInPackagePhotoPipe,
    ProductPricePipe,
    ProductPhotoPipe,
    OneTextFromListPipe,
    CheckedOrUncheckedPipe,
    SumOfProductsInBasketOfTheSelectedPhotoPipe,
    LookBookPricePipe,
    PrintFramePricePipe,
    FileNamePipe,
    TabloPricePipe,
  ],
})
export class ShoppingCartBackModule {}
